import Request from './request'

const Device_List = {
  getCustomListUser (callback) {
    Request.get('device-list/user').then(callback).catch(this.bad_answer)
  },
  getCustomListAll (callback) {
    Request.get('device-list').then(callback).catch(this.bad_answer)
  },
  createCustomDeviceList (params, callback) {
    Request.post('device-list/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  editCustomDeviceList (id, params, callback) {
    Request.post('device-list/edit/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteCustomDeviceList (id, callback) {
    Request.delete('device-list/delete/' + id).then(callback).catch(this.bad_answer)
  },
  getInfoCustomDeviceList (id, callback) {
    Request.post('device-list/view/' + id).then(callback).catch(this.bad_answer)
  },
  addDevicesCustomDeviceList (params, callback) {
    Request.post('device-list/add-devices', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeDeviceCustomDeviceList (list_id, dev_id, callback) {
    Request.delete('device-list/remove-device?device_list_id='+ list_id +'&device_id='+ dev_id).then(callback).catch(this.bad_answer)
  },

}
export default Device_List
